import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import { useState } from "react";
import ClaimPrizeSteps from "./ClaimPrizeSteps";
import ClaimPrizeFail from "./ClaimPrizeFail";
import { useRefreshItems } from "hooks/useRefreshItems";
import { useRemoveActiveItem } from "hooks/useRemoveActiveItem";
import ModalWindow from "components/ModalWindow";

const ClaimPrizePopup = ({ close }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState("start");
  const refresh = useRefreshItems();
  const removeActiveItem = useRemoveActiveItem();

  const closeWindow = () => {
    if (step === 'fail' || step === 'success') {
      refresh();
      removeActiveItem();
      close();
    } else close()
  }

  return (
    <ModalWindow close={close}>
      <div
        className="modal-window__wrapper"
        onClick={(e) => e.stopPropagation()}
      >
        <PagePopopCloseButton close={closeWindow} />
        {step !== 'fail' ?
          <ClaimPrizeSteps
            step={step}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            close={closeWindow}
          />
          :
          <ClaimPrizeFail close={closeWindow} />
        }
      </div>
    </ModalWindow>
  );
};

export default ClaimPrizePopup;
